import { request, qs } from './api';

// Restaurant moderation — same shape/flow as hotels, different base path.
// All endpoints require the admin JWT (handled by request()).

// GET /admin/restaurants?page&limit&search -> { data:[{id,type,name,address,city,lat,lon}], total, page, limit }
export const listRestaurants = (params) => request(`/restaurants${qs(params)}`);

// PUT /admin/restaurants/:id { lat?, lon?, address? } -> { data: Row }. Sending none -> 400.
export const updateRestaurant = (id, body) => request(`/restaurants/${id}`, { method: 'PUT', body });

// DELETE /admin/restaurants/:id -> { data: { id, type, deleted:true } }
export const deleteRestaurant = (id) => request(`/restaurants/${id}`, { method: 'DELETE' });

// POST /admin/restaurants/bulk — [{ id, lat?, lon?, address?, delete? }, ...]
// delete:true removes the row; otherwise the supplied fields are updated.
// -> { data: { results, updated, deleted, failed, total } }
export const bulkRestaurants = (items) => request('/restaurants/bulk', { method: 'POST', body: items });
